export default {
  en: {
    TAG_SELECTOR_EMPTY_TAB_PLACEHOLDER_TEXT:
      'Start typing to search for tags...',
    FILTER_SELECTOR_EMPTY_TAB_PLACEHOLDER_TEXT:
      'Start typing to search for filters/tags...',
    RECENTLY_USED: 'Recently Used',
    TAG_SELECTOR_SELECT_PLACEHOLDER: 'Select Tag',
    TAG_SELECTOR_SEARCH_PLACEHOLDER: 'Select Tag'
  }
};
